/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo, useRef } from 'react';
import { v4 as uuid } from 'uuid';
import { Label } from '../../../Label';
import { Select } from '../../../Select';
import { visual } from '../../strings';
const formatOptionValue = (colId, isDesc) => {
    return `${colId}-${isDesc ? 'desc' : 'asc'}`;
};
const generateSortValue = (columns) => {
    const selectedCol = columns.find(col => col.isSorted);
    return selectedCol
        ? formatOptionValue(selectedCol.id, !!selectedCol.isSortedDesc)
        : undefined;
};
const SortSelect = ({ tableInstance: { toggleSortBy, columns }, getAriaLive = visual.getSortOptionsCardListHeader, }) => {
    const { current: selectId } = useRef(`sort-select-${uuid()}`);
    const selectOptions = useMemo(() => getAriaLive(columns, 'ascending', 'descending'), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [columns]);
    return columns.some(col => col.isSortable) ? (React.createElement(React.Fragment, null,
        React.createElement(Label, { htmlFor: selectId }, "Sort by"),
        React.createElement(Select, { id: selectId, options: selectOptions, value: generateSortValue(columns), onChange: (e) => {
                const [id, order] = e.target.value.split('-');
                if (id.length && order.length) {
                    toggleSortBy(id, order === 'desc', false);
                }
            }, mb: "md" }))) : (React.createElement(React.Fragment, null));
};
export { SortSelect };
//# sourceMappingURL=SortSelect.js.map